var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ic-error-a",
    d: "M15 5C9.4771525 5 5 9.4771525 5 15 5 20.5228475 9.4771525 25 15 25 20.5228475 25 25 20.5228475 25 15 25 9.4771525 20.5228475 5 15 5zM19.6496852 17.9583417C19.9518136 18.2604709 20.0698082 18.7008339 19.9592215 19.1135501 19.8486349 19.5262664 19.5262677 19.8486344 19.1135526 19.9592214 18.7008375 20.0698084 18.2604757 19.9518135 17.9583473 19.6496842L15 16.6913289 12.0416528 19.6496842C11.7395243 19.9518135 11.2991626 20.0698084 10.8864474 19.9592214 10.4737323 19.8486344 10.1513651 19.5262664 10.0407785 19.1135501 9.93019179 18.7008339 10.0481864 18.2604709 10.3503148 17.9583417L13.3086621 14.9999864 10.3503148 12.041631C9.88326478 11.5745797 9.88326479 10.8173399 10.3503149 10.3502885 10.8173649 9.8832372 11.5746027 9.88323719 12.0416528 10.3502885L15 13.3086438 17.9583473 10.3502885C18.4253973 9.88323716 19.1826351 9.88323716 19.6496852 10.3502885 20.1167353 10.8173399 20.1167353 11.5745797 19.6496852 12.041631L16.6913379 14.9999864 19.6496852 17.9583417z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ff6562",
    xlinkHref: "#ic-error-a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.ecbdaac5.svg";
export { ForwardRef as ReactComponent };